export default __webpack_public_path__ + "static/media/mountain.05f50ba2.png";